/**
 * Query and mutation `meta` flag: errors never reach the console, toasts or telemetry, because the order page
 * errors carry the order token in the URL and the BLIK code in the request body. Unlike `errorHandledLocally`,
 * which only drops the global toast.
 */
export const SILENT_ERRORS_META = "silentErrors";

export const hasSilentErrors = (meta: Record<string, unknown> | undefined) =>
  meta?.[SILENT_ERRORS_META] === true;
